import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form } from 'antd'
import type { Tables } from '@muaa/shared'
import { ReleaseFormFields } from './ReleaseFormFields'

type Release = Tables<'releases'>

export function ReleaseEdit() {
  const { formProps, saveButtonProps } = useForm<Release>()

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <ReleaseFormFields />
      </Form>
    </Edit>
  )
}
